import { useAIExperienceCommonDataContext } from './useAIExperienceCommonData';
export function useEngagementPlatform() {
  var _useAIExperienceCommo = useAIExperienceCommonDataContext(),
    engagementPlatformApi = _useAIExperienceCommo.engagementPlatformApi;
  if (!engagementPlatformApi) {
    return {
      startMessage: function startMessage() {
        return Promise.resolve(false);
      },
      stopMessage: function stopMessage() {
        return Promise.resolve(false);
      }
    };
  }
  return engagementPlatformApi;
}